import { useState } from "react";

import { getMapyCzUrlFromKrovak } from "../../../utils/geo";
import { getCoordinateString } from "../../../utils/stringUtils";
import { useTranslation } from "react-i18next";
import IconButton from "../../buttons/IconButton";
import QRCodeLinkDialog from "../../dialogs/QRCodeLinkDialog";
import { namespaces } from "../../../consts/i18n";

const PointItem = ({
  label,
  coordinate,
  dimension,
  isLoading,
  onEdit,
  onDelete,
  serviceType = null,
}) => {
  const onCopyClick = () => {
    navigator.clipboard.writeText(getCoordinateString(coordinate, dimension));
  };

  const formattedCoordinate = getCoordinateString(coordinate, dimension);

  const [isQRCodeDialogOpen, setIsQRCodeDialogOpen] = useState(false);
  const [qrcodeLinkData, setQRCodeLinkData] = useState(null);

  const onQRCodeClick = () => {
    const url = getMapyCzUrlFromKrovak(coordinate[0], coordinate[1], 18);
    setQRCodeLinkData(url);
    setIsQRCodeDialogOpen(true);
  };

  const handleEditClick = () => {
    if (onEdit) onEdit();
  };

  const handleDeleteClick = () => {
    if (onDelete) {
      onDelete();
    }
  };

  const { t } = useTranslation(namespaces.viewer);

  const badgeColor = {
    INSURANCE_EVENT: "text-green-700",
    WARRANTY: "text-violet-600",
    POST_WARRANTY: "text-red-700",
  };

  return (
    <div className="flex flex-col justify-between items-center gap-2">
      <div className="flex justify-between items-center w-full">
        <span className="text-700 text-sm font-bold">{label}</span>
        <span className="text-400 text-sm">{formattedCoordinate}</span>
      </div>
      {!isLoading && (
        <div className="grow flex flex-row-reverse justify-between items-center w-full">
          <div className="flex flex-row justify-between gap-3 items-center">
            <IconButton
              size={24}
              onClick={onCopyClick}
              icon={"/images/sidebar_copy.svg"}
              title={t("sidebar.measure.copyCoordinates") + " " + label}
            />
            {onEdit && (
              <IconButton
                size={14}
                onClick={handleEditClick}
                icon={"/images/sidebar_edit_mini.svg"}
                title={t("sidebar.measure.editPoint")}
              />
            )}
            <IconButton
              size={18}
              onClick={onQRCodeClick}
              icon={"/images/sidebar_pin.svg"}
              // icon={"/images/sidebar_sendtomobile.svg"}
              title={t("sidebar.measure.openShareMapyCzDialog")}
            />

            {onDelete && (
              <IconButton
                size={18}
                onClick={handleDeleteClick}
                icon={"/images/sidebar_trash_mini.svg"}
                title={t("sidebar.measure.delete")}
              />
            )}
          </div>
          {serviceType && (
            <p className={`text-sm font-bold ${badgeColor[serviceType]}`}>
              {t(`form.${serviceType}`)}
            </p>
          )}
        </div>
      )}
      <QRCodeLinkDialog
        isOpen={isQRCodeDialogOpen}
        link={qrcodeLinkData}
        onClose={() => {
          setIsQRCodeDialogOpen(false);
        }}
      />
    </div>
  );
};

export default PointItem;
